import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import theme from '../../../../../../../theme';
import { getAvailabilityDescriptionText } from '../../../../../../../utils/helpers/people/availabilityHelpers';
import { selectCurrentVenue } from '../../../../../../../redux/slices/currentUserSlice';
import { getVenueTimezone } from '../../../../../../../utils/venueTimeFormatters';
import Spinner from '../../../../../../../assets/svg/spinner';
import {
  EventsContainer,
  EventItem,
  BoxContentItem,
  DescriptionText,
  EmptyBoxContent,
  ActionsContainer,
  TimeIconButton,
} from './Events.styles';

const Events = ({ events, onClick, isLoading, onTimeClick, canEdit = false }) => {
  const currentVenue = useSelector(selectCurrentVenue);
  const venueTimezone = getVenueTimezone(currentVenue);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      style={{ width: '100%' }}
    >
      {isLoading && (
        <EmptyBoxContent>
          <Spinner />
        </EmptyBoxContent>
      )}

      {!isLoading && events?.length === 0 && (
        <EmptyBoxContent>
          <Typography variant="bodyRegular" color={theme.colors.gray}>
            No events available
          </Typography>
        </EmptyBoxContent>
      )}

      {!isLoading && events?.length > 0 && (
        <EventsContainer>
          {events.map((event, index) => (
            <BoxContentItem
              key={`${event.id}-${index}`}
              onClick={canEdit ? () => onClick(event) : undefined}
              $canEdit={canEdit}
            >
              <EventItem>
                <Typography variant="bodyRegular" color={theme.colors.white}>
                  {event.label}
                </Typography>
                <DescriptionText variant="navbar">
                  {getAvailabilityDescriptionText(event, venueTimezone)}
                </DescriptionText>
              </EventItem>
              {canEdit && (
                <ActionsContainer>
                  {(event.type === 'FULL_DAYS' || event.type === 'RECURRING_FULL_DAYS') && onTimeClick && (
                    <TimeIconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onTimeClick(event);
                      }}
                    >
                      <AccessTimeIcon fontSize="small" />
                    </TimeIconButton>
                  )}
                  <ChevronRightIcon fontSize="small" />
                </ActionsContainer>
              )}
            </BoxContentItem>
          ))}
        </EventsContainer>
      )}
    </motion.div>
  );
};

export default React.memo(Events);
